import { render, staticRenderFns } from "./Table1.vue?vue&type=template&id=c975be9a&scoped=true&"
import script from "./Table1.vue?vue&type=script&lang=js&"
export * from "./Table1.vue?vue&type=script&lang=js&"
import style0 from "./Table1.vue?vue&type=style&index=0&id=c975be9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c975be9a",
  null
  
)

export default component.exports